/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UsernameWithPopoverContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"UserPopoverContainer_viewer">;
    readonly " $refType": "UsernameWithPopoverContainer_viewer";
};
export type UsernameWithPopoverContainer_viewer$data = UsernameWithPopoverContainer_viewer;
export type UsernameWithPopoverContainer_viewer$key = {
    readonly " $data"?: UsernameWithPopoverContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"UsernameWithPopoverContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UsernameWithPopoverContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserPopoverContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '92a20b5b678539f299c26267d9710789';
export default node;
